import React, { useState } from "react";
import Modal from "../components/Modal";
import API_BASE from "../config.js";
import { useTranslation } from "react-i18next";
import useTextosSegmento from "../i18n/useTextosSegmento";
// Catalogo de servicos com busca sem acento e ordenacao que aprende com o
// uso da oficina. Modulo ja existente -- ver o cabecalho dele.
import { sugerir, registrarUso } from "../services/catalogoServicos";

// Componente de orcamento completo reutilizavel (OS e Agendamentos)
export default function ModalOrcamentoCompleto({
  titulo, osId, tenantId, modeloInicial, featuresLiberadas,
  onConfirmar, onFechar, orcCfg, logoUrl,
  // Identidade do documento. Este componente hoje e usado so pelo fluxo de
  // agendamento, que manda a proposta ANTES de o cliente aprovar -- por isso
  // o Agendamentos.js passa "pre_orcamento". O padrao continua "orcamento",
  // entao qualquer outro uso (agora ou depois) sai igual ao de hoje.
  tipoDocumento = "orcamento",
  // Cliente e veiculo, para o documento de pre-orcamento. Opcional: sem ele
  // o bloco nao e renderizado e nada mais muda.
  cliente = null,
}) {
  const { t } = useTranslation();
  // AUD-F: t() sensivel ao segmento, para as chamadas de vocabulario
  // de veiculo desta tela. O resto segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const ehPre = tipoDocumento === "pre_orcamento";
  const rotuloDoc = ehPre
    ? t("os.orc.doc.badge_pre_orcamento", "PRÉ-ORÇAMENTO")
    : t("os.orc.doc.badge_orcamento");
  // Linha de ressalva do pre-orcamento. Null quando nao e pre: o JSX
  // simplesmente nao renderiza nada e o documento sai como sempre saiu.
  const avisoPre = ehPre ? (
    <div style={{background:"#fffbeb",border:"1px solid #fde68a",borderRadius:6,color:"#92400e",fontSize:11,lineHeight:1.6,marginBottom:14,padding:"8px 12px"}}>
      {tSeg("os.orc.doc.aviso_pre_orcamento", "Documento de proposta: os valores dependem da aprovação do cliente e podem mudar após a inspeção do veículo.")}
    </div>
  ) : null;
  const [step, setStep] = useState(1);
  const [itens, setItens] = useState([]);
  // O pre-orcamento tem layout proprio e unico: sempre Basico. E o que o
  // distingue do documento final, que sai pela O.S. nos tres modelos.
  const [modelo, setModelo] = useState(ehPre ? "basico" : (modeloInicial || "basico"));
  const [fotos, setFotos] = useState([]);
  const [painelFotos, setPainelFotos] = useState(false);
  const [itemNome, setItemNome] = useState("");
  const [itemPreco, setItemPreco] = useState("");

  const plano = ((sessionStorage.getItem("plano")||localStorage.getItem("plano"))||"basico").toLowerCase();
  const modelosDisponiveis = [
    "basico",
    ...(featuresLiberadas?.includes("orcamento_profissional")||plano==="premium"?["profissional"]:[]),
    ...(featuresLiberadas?.includes("orcamento_premium")||plano==="premium"?["premium"]:[])
  ];

  const total = itens.reduce((a,i)=>a+(Number(i.preco)||0),0);

  const addItem = () => {
    if(!itemNome) return;
    setItens(l=>[...l,{nome:itemNome,preco:Number(itemPreco)||0,qtd:1}]);
    // Item digitado a mao tambem entra no aprendizado: da proxima vez ele
    // aparece na lista de sugestoes desta oficina.
    try { registrarUso({ nome: itemNome, preco: Number(itemPreco)||0 }); } catch {}
    setItemNome(""); setItemPreco("");
  };

  // Servicos que a propria oficina cadastrou em Configuracoes > Orcamento.
  // Vem antes do catalogo geral: sao os precos reais dela.
  const servicosDaOficina = [];
  (orcCfg?.tipos || []).forEach(tp => (tp?.itens || []).forEach(i => {
    if (i && i.nome) servicosDaOficina.push({ nome: i.nome, preco: Number(i.preco)||0, _daOficina: true });
  }));

  const _semAcento = (s) => String(s||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"");

  // Campo vazio -> os mais usados da oficina. Campo preenchido -> filtra.
  // Os itens da oficina primeiro, depois o catalogo, sem repetir nome.
  const termoBusca = _semAcento(itemNome).trim();
  const _meus = termoBusca
    ? servicosDaOficina.filter(s => _semAcento(s.nome).includes(termoBusca))
    : servicosDaOficina;
  const _catalogo = sugerir(itemNome, 8).filter(
    s => !_meus.find(m => _semAcento(m.nome) === _semAcento(s.nome))
  );
  const sugestoes = [..._meus.slice(0,4), ..._catalogo]
    .filter(s => !itens.find(x => _semAcento(x.nome) === _semAcento(s.nome)))
    .slice(0,7);

  const adicionarSugestao = (s) => {
    const preco = Number(s.preco)||0;
    setItens(l => l.find(x => x.nome === s.nome) ? l : [...l, {nome:s.nome, preco, qtd:1}]);
    try { registrarUso({ nome: s.nome, preco }); } catch {}
    setItemNome(""); setItemPreco("");
  };

  const confirmar = () => {
    setStep(2);
  };

  // Impressao isolada em janela propria. window.print() direto saia em branco
  // porque o documento (#print-doc-ag) fica dentro do Modal (portal em
  // position:fixed com scroll), contexto em que a regra @media print nao
  // renderiza o conteudo. Como o documento usa apenas estilos inline, copiar
  // o outerHTML para uma janela limpa reproduz o orcamento identico e imprime
  // de forma confiavel -- mesma tecnica ja usada em OrcamentoDetalhe.js.
  const imprimirOrcamento = () => {
    const el = document.getElementById("print-doc-ag");
    if (!el) { window.print(); return; }
    const win = window.open("", "_blank", "width=900,height=700");
    if (!win) { window.print(); return; }
    win.document.write(
      "<!DOCTYPE html><html><head><meta charset='utf-8'><title>" +
      (titulo ? rotuloDoc + " — " + titulo : rotuloDoc) +
      "</title><style>@media print{@page{margin:12mm}}body{margin:0;background:#fff}</style></head><body>" +
      el.outerHTML +
      "</body></html>"
    );
    win.document.close();
    win.focus();
    const disparar = () => { win.print(); };
    // Aguarda imagens (logo) carregarem antes de imprimir para nao sair vazio.
    const imgs = win.document.images;
    if (imgs && imgs.length > 0) {
      let restantes = imgs.length;
      const done = () => { if (--restantes <= 0) setTimeout(disparar, 100); };
      for (let i = 0; i < imgs.length; i++) {
        if (imgs[i].complete) done();
        else { imgs[i].onload = done; imgs[i].onerror = done; }
      }
    } else {
      setTimeout(disparar, 150);
    }
  };

  const salvar = () => {
    onConfirmar({itens, total, modelo, fotos});
  };

  let nomeFallback = "Oficina";
  try {
    const cacheKey = tenantId ? ("saas_config_tenant_" + tenantId) : "saas_config";
    const cached = JSON.parse(localStorage.getItem(cacheKey) || "{}");
    if (cached && cached.nome) nomeFallback = cached.nome;
  } catch {}
  const nomeOficina = orcCfg?.nomeEmpresa || nomeFallback;
  const telefoneOficina = orcCfg?.telefone || "";
  const enderecoOficina = orcCfg?.endereco || "";
  const documentoOficina = orcCfg?.documento || "";
  const emailOficina = orcCfg?.email || "";
  const hoje = new Date().toLocaleDateString("pt-BR");

  // Paleta clara so para o pre-orcamento. Redefine as variaveis do tema
  // dentro deste container: campos, listas e rotulos acompanham sozinhos,
  // porque nenhum deles tem cor propria -- todos leem var(--...).
  // A margem negativa de 32 cobre o padding do cartao do Modal, que e
  // escuro e vem de outro componente, compartilhado com o sistema inteiro.
  const estiloClaro = ehPre ? {
    "--bg2": "#ffffff",
    "--bg3": "#f1f5f9",
    "--bg4": "#e2e8f0",
    "--border": "#cbd5e1",
    "--text": "#0f172a",
    "--text2": "#475569",
    "--text3": "#64748b",
    background: "#ffffff",
    borderRadius: 18,
    margin: -32,
    padding: 32,
    color: "#0f172a",
  } : undefined;

  return (
    <Modal onClose={onFechar} largura={step===2?900:700}>
    <div style={estiloClaro}>
      <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:16}}>
        <div>
          <div style={{color:"var(--accent2)",fontSize:12,marginBottom:2}}>{step===1?t("orcamentos.wiz_label_orcamento"):t("orcamentos.wiz_label_pre_visualizacao")}</div>
          <div style={{fontSize:16,fontWeight:800}}>{titulo}</div>
        </div>
        <div style={{display:"flex",gap:8}}>
          {step===2&&<button onClick={()=>setStep(1)} style={{background:"transparent",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>{t("common.editar")}</button>}
          {step===2&&<button onClick={imprimirOrcamento} style={{background:"#16a34a",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>{t("orcamentos.wiz_imprimir_pdf")}</button>}
          <button onClick={onFechar} style={{background:"var(--bg3)",border:"none",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:18,padding:"4px 10px"}}>x</button>
        </div>
      </div>

      {step===1&&(
        <div>
          {/* Sem escolha de modelo no pre-orcamento: ele e sempre Basico. */}
          {!ehPre && (
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            {modelosDisponiveis.map(m=>(
              <button key={m} onClick={()=>setModelo(m)}
                style={{background:modelo===m?"var(--accent)":"var(--bg3)",border:"1px solid "+(modelo===m?"var(--accent)":"var(--border)"),borderRadius:8,color:modelo===m?"#fff":"var(--text2)",cursor:"pointer",fontSize:12,fontWeight:600,padding:"6px 16px",textTransform:"capitalize"}}>
                {m.charAt(0).toUpperCase()+m.slice(1)}
              </button>
            ))}
          </div>
          )}
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            <input value={itemNome} onChange={e=>setItemNome(e.target.value)} placeholder={t("orcamentos.wiz_desc_placeholder")} style={{flex:1}} onKeyDown={e=>e.key==="Enter"&&addItem()} />
            <input value={itemPreco} onChange={e=>setItemPreco(e.target.value)} placeholder={t("orcamentos.wiz_preco_placeholder")} type="number" style={{width:100}} onKeyDown={e=>e.key==="Enter"&&addItem()} />
            <button onClick={addItem} style={{background:"var(--accent)",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"8px 14px"}}>{t("orcamentos.wiz_add")}</button>
          </div>
          {/* Sugestoes: clique adiciona com o preco ja preenchido. */}
          {sugestoes.length>0 && (
            <div style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,marginBottom:12,overflow:"hidden"}}>
              <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,letterSpacing:"0.08em",padding:"8px 12px 6px",textTransform:"uppercase"}}>
                {itemNome
                  ? t("orcamentos.wiz_sugestoes", "Sugestões")
                  : t("orcamentos.wiz_mais_usados", "Mais usados nesta oficina")}
              </div>
              {sugestoes.map((s,i)=>(
                <button key={s.nome+i} onClick={()=>adicionarSugestao(s)}
                  style={{alignItems:"center",background:"transparent",border:"none",borderTop:"1px solid var(--border)",color:"var(--text)",cursor:"pointer",display:"flex",fontSize:13,gap:10,justifyContent:"space-between",padding:"9px 12px",textAlign:"left",width:"100%"}}>
                  <span style={{alignItems:"center",display:"flex",gap:8}}>
                    {s.nome}
                    {s._daOficina && (
                      <span style={{background:"rgba(180,83,9,.18)",border:"1px solid rgba(180,83,9,.5)",borderRadius:4,color:"#d97706",fontSize:9,fontWeight:700,letterSpacing:"0.06em",padding:"1px 6px",textTransform:"uppercase"}}>
                        {t("orcamentos.wiz_tabela_oficina", "sua tabela")}
                      </span>
                    )}
                  </span>
                  <span style={{color:"#22c55e",fontWeight:600,whiteSpace:"nowrap"}}>R$ {Number(s.preco).toFixed(2)}</span>
                </button>
              ))}
            </div>
          )}
          {itens.length>0&&(
            <div style={{background:"var(--bg3)",borderRadius:8,marginBottom:12,padding:12}}>
              {itens.map((it,i)=>(
                <div key={i} style={{alignItems:"center",borderBottom:"1px solid var(--border)",display:"flex",justifyContent:"space-between",padding:"6px 0"}}>
                  <span style={{fontSize:13}}>{it.nome}</span>
                  <div style={{alignItems:"center",display:"flex",gap:8}}>
                    <span style={{color:"#22c55e",fontWeight:600}}>R$ {Number(it.preco).toFixed(2)}</span>
                    <button onClick={()=>setItens(l=>l.filter((_,j)=>j!==i))} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer"}}>x</button>
                  </div>
                </div>
              ))}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8,fontWeight:700}}>
                <span>{t("orcamentos.wiz_total")}</span>
                <span style={{color:"#22c55e",fontSize:16}}>R$ {total.toFixed(2)}</span>
              </div>
            </div>
          )}
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button onClick={confirmar} style={{background:"#16a34a",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 20px"}}>{t("orcamentos.wiz_ver_pre_visualizacao")}</button>
          </div>
        </div>
      )}

      {step===2&&(
        <div>
          {/* Idem: no pre-orcamento nao ha o que escolher. */}
          {!ehPre && (
          <div style={{display:"flex",gap:8,marginBottom:12}}>
            {modelosDisponiveis.map(m=>(
              <button key={m} onClick={()=>setModelo(m)}
                style={{background:modelo===m?"var(--accent)":"var(--bg3)",border:"1px solid "+(modelo===m?"var(--accent)":"var(--border)"),borderRadius:8,color:modelo===m?"#fff":"var(--text2)",cursor:"pointer",fontSize:11,padding:"4px 12px",textTransform:"capitalize"}}>
                {m.charAt(0).toUpperCase()+m.slice(1)}
              </button>
            ))}
          </div>
          )}
          <div id="print-doc-ag">
            {/* ------------------------------------------------------------------
                DOCUMENTO DE PRE-ORCAMENTO -- desenho proprio, usado so aqui.
                Estilos inline de proposito: a impressao copia o outerHTML deste
                bloco para outra janela, onde nenhuma folha de estilo existe.
               ------------------------------------------------------------------ */}
            {ehPre && (
              <div style={{background:"#fff",color:"#1f2937",fontFamily:"Georgia, 'Times New Roman', serif",overflow:"hidden",padding:"40px 44px",position:"relative"}}>
                {/* Marca d'agua com o logo DAQUELA oficina (mesmo orcCfg do
                    cabecalho). <img> posicionado, nao background CSS: navegador
                    costuma descartar imagem de fundo na impressao, e assim ela
                    sai no PDF. Sem logo cadastrado, nao aparece nada. */}
                {logoUrl && (
                  <img src={logoUrl} alt="" aria-hidden="true"
                    style={{left:"50%",maxWidth:430,opacity:0.055,pointerEvents:"none",position:"absolute",top:"50%",transform:"translate(-50%,-50%)",userSelect:"none",width:"66%",zIndex:0}} />
                )}
                {/* Todo o conteudo numa camada acima da marca d'agua. */}
                <div style={{position:"relative",zIndex:1}}>

                <div style={{alignItems:"flex-end",display:"flex",justifyContent:"space-between",marginBottom:26}}>
                  <div>
                    {logoUrl && <img src={logoUrl} alt="logo" style={{display:"block",height:64,marginBottom:12,objectFit:"contain",background:"none",border:"none"}} />}
                    <div style={{fontSize:15,fontWeight:700,letterSpacing:"0.04em"}}>{nomeOficina}</div>
                    <div style={{color:"#6b7280",fontSize:11,lineHeight:1.7,marginTop:3}}>
                      {telefoneOficina && <div>{t("os.orc.doc.tel_prefix")} {telefoneOficina}</div>}
                      {enderecoOficina && <div>{enderecoOficina}</div>}
                      {documentoOficina && <div>CNPJ/CPF: {documentoOficina}</div>}
                      {emailOficina && <div>{emailOficina}</div>}
                    </div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#78716c",fontSize:9,letterSpacing:"0.18em",textTransform:"uppercase"}}>{t("os.orc.doc.ref_prefix")}</div>
                    <div style={{fontSize:14,fontWeight:700}}>{osId}</div>
                    <div style={{color:"#78716c",fontSize:11,marginTop:6}}>{hoje}</div>
                  </div>
                </div>

                {/* A identidade vem da tipografia, nao de caixa colorida. */}
                <div style={{borderTop:"3px solid #b45309",paddingTop:16}}>
                  <div style={{fontSize:29,fontWeight:400,letterSpacing:"0.2em",lineHeight:1.1}}>{rotuloDoc}</div>
                </div>
                <div style={{borderBottom:"1px solid #d6d3d1",color:"#78716c",fontSize:11,letterSpacing:"0.05em",marginBottom:24,paddingBottom:14}}>
                  {t("os.orc.doc.pre_subtitulo", "Proposta de serviço sujeita à aprovação do cliente")}
                </div>

                {cliente && (
                  <div style={{display:"grid",gap:22,gridTemplateColumns:"1fr 1fr",marginBottom:24}}>
                    <div>
                      <div style={{color:"#78716c",fontSize:9,letterSpacing:"0.16em",marginBottom:3,textTransform:"uppercase"}}>{t("os.orc.doc.cliente")}</div>
                      <div style={{fontSize:14,fontWeight:700}}>{cliente.nome || "—"}</div>
                      {cliente.telefone && <div style={{color:"#6b7280",fontSize:11,marginTop:2}}>{cliente.telefone}</div>}
                    </div>
                    <div>
                      <div style={{color:"#78716c",fontSize:9,letterSpacing:"0.16em",marginBottom:3,textTransform:"uppercase"}}>{tSeg("os.orc.doc.veiculo")}</div>
                      <div style={{fontSize:14,fontWeight:700}}>{cliente.veiculo || "—"}</div>
                      {cliente.placa && <div style={{color:"#6b7280",fontSize:11,letterSpacing:"0.08em",marginTop:2}}>{cliente.placa}</div>}
                    </div>
                  </div>
                )}

                {cliente && cliente.servico && (
                  <div style={{borderLeft:"2px solid #d6d3d1",color:"#44403c",fontSize:12,lineHeight:1.7,marginBottom:24,paddingLeft:14}}>
                    <div style={{color:"#78716c",fontSize:9,letterSpacing:"0.16em",marginBottom:3,textTransform:"uppercase"}}>{t("os.orc.doc.relato_label", "Relato do cliente")}</div>
                    {cliente.servico}
                  </div>
                )}

                {/* Itens em lista com filete pontilhado -- nao em tabela. */}
                <div style={{marginBottom:26}}>
                  <div style={{borderBottom:"1px solid #1f2937",color:"#78716c",display:"flex",fontSize:9,justifyContent:"space-between",letterSpacing:"0.16em",paddingBottom:6,textTransform:"uppercase"}}>
                    <span>{t("os.orc.doc.col_descricao")}</span>
                    <span>{t("os.orc.doc.col_total")}</span>
                  </div>
                  {itens.map((it,i)=>(
                    <div key={i} style={{alignItems:"baseline",borderBottom:"1px dotted #d6d3d1",display:"flex",gap:14,justifyContent:"space-between",padding:"11px 0"}}>
                      <span style={{fontSize:13}}>
                        {it.nome}
                        {(Number(it.qtd)||1) > 1 && (
                          <span style={{color:"#78716c",fontSize:11}}>{"  ×" + (it.qtd) + "  ·  R$ " + (Number(it.preco)/(Number(it.qtd)||1)).toFixed(2) + " cada"}</span>
                        )}
                      </span>
                      <span style={{fontSize:13,fontWeight:700,whiteSpace:"nowrap"}}>R$ {Number(it.preco).toFixed(2)}</span>
                    </div>
                  ))}
                </div>

                <div style={{display:"flex",justifyContent:"flex-end",marginBottom:24}}>
                  <div style={{minWidth:230,textAlign:"right"}}>
                    <div style={{color:"#78716c",fontSize:9,letterSpacing:"0.16em",textTransform:"uppercase"}}>{t("os.orc.doc.total_label")}</div>
                    <div style={{borderTop:"3px double #b45309",fontSize:26,fontWeight:700,marginTop:5,paddingTop:7}}>R$ {total.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                  </div>
                </div>

                {avisoPre}

                {/* O que nenhum dos outros modelos tem: o aceite. E isto que faz
                    dele um documento que ainda vai ser aprovado. */}
                <div style={{borderTop:"1px solid #e7e5e4",display:"grid",gap:44,gridTemplateColumns:"1fr 1fr",marginTop:34,paddingTop:44}}>
                  <div style={{borderTop:"1px solid #1f2937",color:"#6b7280",fontSize:11,paddingTop:7,textAlign:"center"}}>
                    {t("os.orc.doc.pre_assina_cliente", "De acordo — assinatura do cliente")}
                  </div>
                  <div style={{borderTop:"1px solid #1f2937",color:"#6b7280",fontSize:11,paddingTop:7,textAlign:"center"}}>
                    {t("os.orc.doc.pre_data_aprovacao", "Data da aprovação")}
                  </div>
                </div>

                </div>
              </div>
            )}
            {!ehPre && modelo==="basico"&&(
              <div style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:8,color:"#1e293b",fontFamily:"Arial,sans-serif",padding:"28px 32px"}}>
                <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between",marginBottom:24}}>
                  <div>
                    {logoUrl&&<img src={logoUrl} alt="logo" style={{height:70,marginBottom:8,objectFit:"contain",display:"block",background:"none",border:"none"}} />}
                    <div style={{color:"#1e40af",fontSize:20,fontWeight:800}}>{nomeOficina}</div>
                    {telefoneOficina&&<div style={{color:"#64748b",fontSize:12,marginTop:2}}>{t("os.orc.doc.tel_prefix")} {telefoneOficina}</div>}
                    {enderecoOficina&&<div style={{color:"#64748b",fontSize:12}}>{enderecoOficina}</div>}
                    {documentoOficina&&<div style={{color:"#64748b",fontSize:12}}>CNPJ/CPF: {documentoOficina}</div>}
                    {emailOficina&&<div style={{color:"#64748b",fontSize:12}}>{emailOficina}</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{background:ehPre?"#b45309":"#1e40af",borderRadius:6,color:"#fff",display:"inline-block",fontSize:12,fontWeight:700,marginBottom:8,padding:"4px 12px"}}>{rotuloDoc}</div>
                    <div style={{color:"#64748b",fontSize:12}}>{t("os.orc.doc.data_prefix")} {hoje}</div>
                    <div style={{color:"#64748b",fontSize:12}}>{t("os.orc.doc.ref_prefix")} {osId}</div>
                  </div>
                </div>
                {avisoPre}
                <table style={{borderCollapse:"collapse",width:"100%",marginBottom:16}}>
                  <thead><tr style={{background:"#1e40af"}}>
                    {[t("os.orc.doc.col_descricao"),t("os.orc.doc.col_qtd"),t("os.orc.doc.col_valor_unit"),t("os.orc.doc.col_total")].map(h=><th key={h} style={{color:"#fff",fontSize:12,padding:"8px 12px",textAlign:"left"}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {itens.map((it,i)=>(
                      <tr key={i} style={{borderBottom:"1px solid #e2e8f0"}}>
                        <td style={{fontSize:13,padding:"8px 12px"}}>{it.nome}</td>
                        <td style={{fontSize:13,padding:"8px 12px"}}>{it.qtd||1}</td>
                        <td style={{fontSize:13,padding:"8px 12px"}}>R$ {(Number(it.preco)/(it.qtd||1)).toFixed(2)}</td>
                        <td style={{fontSize:13,fontWeight:600,padding:"8px 12px"}}>R$ {Number(it.preco).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{display:"flex",justifyContent:"flex-end",marginBottom:20}}>
                  <div style={{borderTop:"2px solid #1e40af",paddingTop:8,textAlign:"right"}}>
                    <div style={{color:"#64748b",fontSize:11}}>{t("os.orc.doc.total_label")}</div>
                    <div style={{color:"#1e40af",fontSize:22,fontWeight:800}}>R$ {total.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                  </div>
                </div>
                <div style={{background:"#f0fdf4",borderRadius:8,color:"#166534",fontSize:12,padding:"10px 16px"}}>
                  <strong>{t("orcamentos.wiz_politica_label")}</strong> {t("orcamentos.wiz_politica_texto")}
                </div>
              </div>
            )}
            {modelo==="profissional"&&(
              <div style={{background:"#fff",border:"2px solid #1e40af",borderRadius:8,color:"#1e293b",fontFamily:"Arial,sans-serif",padding:"28px 32px"}}>
                <div style={{alignItems:"center",borderBottom:"2px solid #1e40af",display:"flex",justifyContent:"space-between",marginBottom:20,paddingBottom:16}}>
                  <div>
                    {logoUrl&&<img src={logoUrl} alt="logo" style={{height:70,marginBottom:8,objectFit:"contain",display:"block",background:"none",border:"none"}} />}
                    <div style={{color:"#1e40af",fontSize:18,fontWeight:800}}>{nomeOficina}</div>
                    {telefoneOficina&&<div style={{color:"#64748b",fontSize:12,marginTop:2}}>{t("os.orc.doc.tel_prefix")} {telefoneOficina}</div>}
                    {enderecoOficina&&<div style={{color:"#64748b",fontSize:12}}>{enderecoOficina}</div>}
                    {documentoOficina&&<div style={{color:"#64748b",fontSize:12}}>CNPJ/CPF: {documentoOficina}</div>}
                    {emailOficina&&<div style={{color:"#64748b",fontSize:12}}>{emailOficina}</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#1e40af",fontSize:13,fontWeight:700}}>{ehPre ? rotuloDoc : t("orcamentos.wiz_proposta_comercial")}</div>
                    <div style={{color:"#64748b",fontSize:12}}>{t("os.orc.doc.ref_prefix")} {osId} · {hoje}</div>
                  </div>
                </div>
                <table style={{borderCollapse:"collapse",width:"100%",marginBottom:16}}>
                  <thead><tr style={{background:"#eff6ff"}}>
                    {[t("orcamentos.col_servico_peca"),t("os.orc.doc.col_qtd"),t("orcamentos.print_valor"),t("os.orc.doc.col_total")].map(h=><th key={h} style={{color:"#1e40af",fontSize:12,fontWeight:700,padding:"8px 12px",textAlign:"left"}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {itens.map((it,i)=>(
                      <tr key={i} style={{borderBottom:"1px solid #e2e8f0"}}>
                        <td style={{fontSize:13,padding:"8px 12px"}}>{it.nome}</td>
                        <td style={{fontSize:13,padding:"8px 12px"}}>{it.qtd||1}</td>
                        <td style={{fontSize:13,padding:"8px 12px"}}>R$ {(Number(it.preco)/(it.qtd||1)).toFixed(2)}</td>
                        <td style={{color:"#1e40af",fontSize:13,fontWeight:700,padding:"8px 12px"}}>R$ {Number(it.preco).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
                  <div style={{background:"#eff6ff",borderRadius:8,padding:"12px 20px",textAlign:"right"}}>
                    <div style={{color:"#1e40af",fontSize:11}}>{t("orcamentos.wiz_total_proposta")}</div>
                    <div style={{color:"#1e40af",fontSize:22,fontWeight:800}}>R$ {total.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                  </div>
                </div>
              </div>
            )}
            {modelo==="premium"&&(
              <div style={{background:"linear-gradient(135deg,#0f172a,#1e293b)",borderRadius:8,color:"#fff",fontFamily:"Arial,sans-serif",padding:"28px 32px"}}>
                <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between",marginBottom:20}}>
                  <div>
                    {logoUrl&&<img src={logoUrl} alt="logo" style={{height:70,marginBottom:8,objectFit:"contain",display:"block",background:"none",border:"none"}} />}
                    <div style={{color:"#f59e0b",fontSize:11,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase"}}>{ehPre ? rotuloDoc : t("os.orc.doc.relatorio_executivo")}</div>
                    <div style={{color:"#fff",fontSize:18,fontWeight:800}}>{nomeOficina}</div>
                    {telefoneOficina&&<div style={{color:"#94a3b8",fontSize:12,marginTop:2}}>{t("os.orc.doc.tel_prefix")} {telefoneOficina}</div>}
                    {enderecoOficina&&<div style={{color:"#94a3b8",fontSize:12}}>{enderecoOficina}</div>}
                    {documentoOficina&&<div style={{color:"#94a3b8",fontSize:12}}>CNPJ/CPF: {documentoOficina}</div>}
                    {emailOficina&&<div style={{color:"#94a3b8",fontSize:12}}>{emailOficina}</div>}
                  </div>
                  <div style={{textAlign:"right"}}>
                    <div style={{color:"#94a3b8",fontSize:12}}>{t("os.orc.doc.ref_prefix")} {osId}</div>
                    <div style={{color:"#94a3b8",fontSize:12}}>{hoje}</div>
                  </div>
                </div>
                <table style={{borderCollapse:"collapse",width:"100%",marginBottom:16}}>
                  <thead><tr style={{background:"rgba(245,158,11,0.15)"}}>
                    {[t("os.orc.doc.col_descricao"),t("os.orc.doc.col_qtd"),t("orcamentos.print_valor"),t("os.orc.doc.col_total")].map(h=><th key={h} style={{color:"#f59e0b",fontSize:11,fontWeight:700,padding:"8px 12px",textAlign:"left",textTransform:"uppercase"}}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {itens.map((it,i)=>(
                      <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
                        <td style={{color:"#e2e8f0",fontSize:13,padding:"8px 12px"}}>{it.nome}</td>
                        <td style={{color:"#e2e8f0",fontSize:13,padding:"8px 12px"}}>{it.qtd||1}</td>
                        <td style={{color:"#e2e8f0",fontSize:13,padding:"8px 12px"}}>R$ {(Number(it.preco)/(it.qtd||1)).toFixed(2)}</td>
                        <td style={{color:"#f59e0b",fontSize:13,fontWeight:700,padding:"8px 12px"}}>R$ {Number(it.preco).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
                  <div style={{background:"rgba(245,158,11,0.1)",border:"1px solid #f59e0b",borderRadius:8,padding:"12px 20px",textAlign:"right"}}>
                    <div style={{color:"#f59e0b",fontSize:11}}>{t("os.orc.doc.investimento_total")}</div>
                    <div style={{color:"#f59e0b",fontSize:22,fontWeight:800}}>R$ {total.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
            <button onClick={salvar} style={{background:"#16a34a",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 20px"}}>
              {t("orcamentos.wiz_confirmar_enviar")}
            </button>
          </div>
        </div>
      )}
    </div>
    </Modal>
  );
}
